var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2000_20657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.31348 1.33203H5.98014C2.64681 1.33203 1.31348 2.66536 1.31348 5.9987V9.9987C1.31348 13.332 2.64681 14.6654 5.98014 14.6654H9.98014C13.3135 14.6654 14.6468 13.332 14.6468 9.9987V8.66536",
    stroke: "#1F2937",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5863 2.37218C13.7663 4.41884 11.7063 7.20551 9.9863 8.58551L8.93297 9.42551C8.79964 9.52551 8.6663 9.60551 8.51297 9.66551C8.51297 9.56551 8.5063 9.46551 8.49297 9.35884C8.43297 8.91218 8.23297 8.49218 7.87297 8.13884C7.5063 7.77218 7.0663 7.56551 6.61297 7.50551C6.5063 7.49884 6.39964 7.49218 6.29297 7.49884C6.35297 7.33218 6.43964 7.17884 6.55297 7.05218L7.39297 5.99884C8.77297 4.27884 11.5663 2.20551 13.6063 1.38551C13.9196 1.26551 14.2263 1.35884 14.4196 1.55218C14.6196 1.75218 14.713 2.05884 14.5863 2.37218Z",
    stroke: "#1F2937",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51974 9.66162C8.51974 10.2483 8.29307 10.8083 7.87307 11.2349C7.5464 11.5616 7.1064 11.7883 6.57974 11.8549L5.2664 11.9949C4.55307 12.0749 3.93974 11.4683 4.01974 10.7416L4.15974 9.42828C4.2864 8.26162 5.25974 7.51495 6.29974 7.49495C6.4064 7.48828 6.51307 7.49495 6.61974 7.50162C7.07307 7.56162 7.51307 7.76828 7.87974 8.13495C8.23974 8.49495 8.43974 8.90828 8.49974 9.35495C8.51307 9.46162 8.51974 9.56828 8.51974 9.66162Z",
    stroke: "#1F2937",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5462 7.9876C10.5462 6.59427 9.41953 5.46094 8.01953 5.46094",
    stroke: "#1F2937",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2000_20657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.4b511d1c2cfbc2672688e8697786ec80.svg";
export { ForwardRef as ReactComponent };